import { render, staticRenderFns } from "./AdminComment.vue?vue&type=template&id=2a5c8ea0&scoped=true&"
import script from "./AdminComment.vue?vue&type=script&lang=js&"
export * from "./AdminComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c8ea0",
  null
  
)

export default component.exports